import { Injectable } from '@angular/core';
import { Http, Jsonp } from '@angular/http';
import 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { VersionService } from '../services/version.service';
import { Config } from '../classes/config';

@Injectable()
export class BudgetChangesService {
  constructor(
    private _http: Http,
    private _jsonp: Jsonp,
    private ver: VersionService
  ) {}

  getLower(id: number) {
    return this._http
      .get(
        `${
          Config.apiUrl
        }/wijziging?11&programma=${id.toString()}&type=0&versionId=${this.ver.activeVersion()}&callback=?`
      )
      .map(resp => resp.json());
  }

  getUpper(id: number) {
    return this._http
      .get(
        `${
          Config.apiUrl
        }/wijziging?11&programma=${id.toString()}&type=1&versionId=${this.ver.activeVersion()}&callback=?`
      )
      .map(resp => resp.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/budget-changes.service.ts